export default __webpack_public_path__ + "static/media/buddi-logo.1885d629.png";